/**
 * Utility functions for smooth scrolling
 */

/**
 * Smoothly scroll to the top of the page
 * @param {boolean} smooth - Whether to use smooth scrolling (default: true)
 */
export const scrollToTop = (smooth = true) => {
  window.scrollTo({ 
    top: 0, 
    behavior: smooth ? 'smooth' : 'auto' 
  });
};

/**
 * Smoothly scroll to a specific element
 * @param {string} elementId - The ID of the element to scroll to
 * @param {boolean} smooth - Whether to use smooth scrolling (default: true)
 */
export const scrollToElement = (elementId, smooth = true) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ 
      behavior: smooth ? 'smooth' : 'auto',
      block: 'start'
    });
  }
};

/**
 * Smoothly scroll to a specific position
 * @param {number} top - The top position to scroll to
 * @param {boolean} smooth - Whether to use smooth scrolling (default: true)
 */
export const scrollToPosition = (top, smooth = true) => {
  window.scrollTo({ 
    top, 
    behavior: smooth ? 'smooth' : 'auto' 
  });
};
